module.exports = __webpack_public_path__ + "static/media/0049.31cc3d77.png";